import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ChangeDetectorRef  } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Card } from 'src/assets/models/Card.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sl07',
  templateUrl: './sl07.component.html',
  styleUrls: ['./sl07.component.scss']
})
export class SL07Component implements OnInit {
  company = environment.company;
  
  @Input() package: any = {};
  @Input() showContentFromSl04: boolean = false;
  protected packageCards: any;
  protected slide004CategoryInView: number = null;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    
  }

  ngOnInit(): void {
    setTimeout(() => {
    if(!this.package || (typeof this.package === 'object' && Object.keys(this.package).length === 0)){
      this.getSL07();
    }
  }, 0);
    this.getCards();
  }

  private getSL07(){
    this.http.get('assets/'+environment.company+'/content/'+this.translate.currentLang+'/home.json', { responseType: 'text' }).subscribe((data) => {
      const homeData = JSON.parse(data);

      const sl07Data = homeData.slides.find((slide: any) => slide.type === 'SL07');
      
      if (sl07Data) {
        this.package = sl07Data;
        this.cdr.detectChanges();
      } else {
        console.log('Non è stato trovato un elemento con type "SL07"');
      }
    });
  }

  private getCards(): void {
    this.http.get('assets/'+environment.company+'/content/'+this.translate.currentLang+'/bestcases/0navigator.json', { responseType: 'text' }).subscribe((data) => {
      this.packageCards = JSON.parse(data);
    });
  }
  
  protected navigateTo(item: Card):void{
    this.router.navigate(['/details', item.file]);
  }

  protected assignCategory(item: any): void {
    this.slide004CategoryInView = item;
  }
}
